import { css, jsx } from '@emotion/react';
import { Animation } from '../../../theme/Animation.es.js';
import '../../../theme/Colors.es.js';
import { Shadows } from '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import 'react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { ServiceIconConfig } from '../ServiceIcon/constants.es.js';

const Styles = labelStyles("ServiceIconShell", {
  root: ({ hasBorder, hasShadow, hasWhiteBackground, size }) => {
    const border = hasBorder ? `var(--zds-border-weak)` : `none`;
    const background = hasWhiteBackground ? "#fff" : "var(--zds-background-weaker)";
    return [
      css`
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${background};
        border: ${border};
        border-radius: ${ServiceIconConfig[size].borderRadius};
      `,
      withModifier(`size`, css`
          height: ${ServiceIconConfig[size].width};
          width: ${ServiceIconConfig[size].width};
        `),
      hasShadow && withModifier("shadowed", css`
            box-shadow: ${Shadows.elevation5};
            transition-duration: ${Animation.transitionDuration};
            transition-property: box-shadow;
            transition-timing-function: ${Animation.transitionTimingFunction};
          `)
    ];
  }
});
const ServiceIconShell = ({ children, hasBorder = true, hasShadow = false, hasWhiteBackground = false, size }) => {
  return jsx("span", { css: Styles.root({
    hasBorder,
    hasShadow,
    hasWhiteBackground,
    size
  }), "data-zds": true, "data-testid": "ServiceIconShell" }, children);
};

export { ServiceIconShell };
//# sourceMappingURL=ServiceIconShell.es.js.map
